(() => {
  'use strict';

  if (customElements.get('video-background')) return;

  customElements.define('video-background', class extends HTMLElement {
    connectedCallback() {
      this.videoId = this.getAttribute('data-video-id');
      this.videoTemplate = this.querySelector('[data-video-template]');
      this.video = this.querySelector('video');
      this.slide = this.closest('.slideshow__slide');
      this.nearViewport = false;
      this.inViewport = false;
      this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);

      if (!this.videoId) return;

      if (this.slide) {
        this.slideObserver = new MutationObserver(() => this.syncVideo());
        this.slideObserver.observe(this.slide, {
          attributes: true,
          attributeFilter: ['class', 'aria-hidden']
        });
      }

      this.videoTemplateObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          this.nearViewport = entry.isIntersecting;
          this.syncVideo();
        }
      }, { rootMargin: '300px', threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
      this.videoTemplateObserver.observe(this);

      this.videoPlayObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          this.inViewport = entry.isIntersecting;
          this.syncVideo();
        }
      }, { rootMargin: '0px', threshold: [0, 1] });
      this.videoPlayObserver.observe(this);
    }

    isActiveSlide() {
      return !this.slide || (
        this.slide.classList.contains('is-selected') &&
        this.slide.getAttribute('aria-hidden') !== 'true'
      );
    }

    syncVideo() {
      if (!this.isConnected) return;

      if (!this.video && this.nearViewport && this.isActiveSlide() && this.videoTemplate) {
        this.innerHTML = this.videoTemplate.innerHTML;
        this.classList.remove('is-loading');
        this.video = this.querySelector('video');
        this.videoTemplate = null;
      }

      if (!this.video) return;

      if (this.inViewport && this.isActiveSlide()) {
        this.powerSaverVideoPlay();
      } else {
        this.video.pause();
      }
    }

    powerSaverVideoPlay() {
      if (!this.video || !this.inViewport || !this.isActiveSlide() || !this.isConnected) return;

      const playback = this.video.play();
      if (playback !== undefined) {
        playback.then(() => {
          if (!this.inViewport || !this.isActiveSlide() || !this.isConnected) this.video.pause();
        }).catch(() => {
          if (!this.isConnected) return;
          document.addEventListener('click', this.powerSaverVideoPlay, { passive: true, once: true });
          document.addEventListener('touchstart', this.powerSaverVideoPlay, { passive: true, once: true });
        });
      }
    }

    disconnectedCallback() {
      this.videoTemplateObserver?.disconnect();
      this.videoPlayObserver?.disconnect();
      this.slideObserver?.disconnect();
      this.video?.pause();
      document.removeEventListener('click', this.powerSaverVideoPlay);
      document.removeEventListener('touchstart', this.powerSaverVideoPlay);
    }
  });
})();